/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {BrowserContextRootEl} from 'common/widgets/browser-context-root';

import {NavColEl} from '../components/nav-col';
import type {DesignSystem} from '../index';
import {AvatarsSection} from './section-avatars';
import {BookmarksWidgetSection} from './section-bookmarks-widget';
import {ButtonsSection} from './section-buttons';
import {CalendarSection} from './section-calendar';
import {ChartsSection} from './section-charts';
import {ColorsSection} from './section-colors';
import {DashboardSelectorSection} from './section-dashboard-selector';
import {DesignSystemSection} from './section-design-system';
import {ErrorsSection} from './section-errors';
import {FormsSection} from './section-forms';
import {IconographySection} from './section-iconography';
import {ItemListsSection} from './section-item-lists';
import {MenusSection} from './section-menus';
import {PanelsSection} from './section-panels';
import {QueryBuilderWidgetsSection} from './section-query-builder-widgets';
import {StylesSection} from './section-styles';
import {TableSection} from './section-table';
import {TypographySection} from './section-typography';

export function template(this: DesignSystem) {
  return (
    <BrowserContextRootEl sel='.design-system'>
      <NavColEl attrs={{sections: this.state.navSections}} />
      <div sel='.content-col' hook={{insert: (vnode) => this.helpers.contentInserted(vnode.elm)}}>
        <DesignSystemSection />
        <ColorsSection />
        <TypographySection />
        <IconographySection designSystem={this} />
        <AvatarsSection />
        <StylesSection />
        <ButtonsSection designSystem={this} />
        <FormsSection designSystem={this} />
        <MenusSection designSystem={this} />
        <PanelsSection designSystem={this} />
        <ItemListsSection designSystem={this} />
        <TableSection designSystem={this} />
        <CalendarSection designSystem={this} />
        <ChartsSection designSystem={this} />
        <QueryBuilderWidgetsSection designSystem={this} />
        <BookmarksWidgetSection designSystem={this} />
        <DashboardSelectorSection designSystem={this} />
        <ErrorsSection />
      </div>
    </BrowserContextRootEl>
  );
}
